function stickyTopNav() {
  
  const stickyTopNavSection = document.querySelector( '.e-stn--sticky-top-nav' );
  const header = document.querySelector( 'header' );
  const adminBar = document.querySelector( '#wpadminbar' );
  

  if ( !stickyTopNavSection || !header ) return;

  const adminBarHeight = adminBar?.offsetHeight || 0;
  const headerHeight = header.offsetHeight + adminBarHeight;
  stickyTopNavSection.style.top = `${headerHeight}px`;
}

window.addEventListener( 'load', stickyTopNav );
window.addEventListener( 'resize', stickyTopNav );